<template>
  <v-container
      class="fill-height"
      fluid>
    <v-row
        align="center"
        justify="center">
      <v-col
          cols="12"
          sm="8"
          md="6"
          lg="4">
        <v-card class="elevation-12">
          <div style="height: 0.5rem;">
            <v-progress-linear
                v-show="loading"
                height="8"
                indeterminate
                color="primary"
            ></v-progress-linear>
          </div>
          <v-card-text>
            <v-container>
              <v-row class="header-image-container">

                <v-col
                    cols="12"
                    sm="12"
                    md="12">
                  <v-img
                      src="./../assets/logo.jpg"
                      lazy-src="./../assets/logo.jpg"
                      class="grey lighten-2"
                      max-width="250"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">

                  <p class="text-left subtitle-1">
                    {{ $t("register.registerText") }}
                  </p>

                  <v-alert v-show="error" type="error"
                           transition="scale-transition">
                    {{ error }}
                  </v-alert>

                  <v-form>
                    <v-text-field
                        :label="$t('common.email') + '*'"
                        name="email"
                        type="text"
                        v-model="user.email"
                        :error-messages="emailErrors"
                        @input="$v.user.email.$touch()"
                        @blur="$v.user.email.$touch()"
                    ></v-text-field>
                    <v-text-field
                        id="password"
                        :label="$t('common.createPassword') + '*'"
                        name="password"
                        v-model="user.password"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                        @click:append="showPassword = !showPassword"

                        :error-messages="passwordErrors"
                        @input="$v.user.password.$touch()"
                        @blur="$v.user.password.$touch()"
                    ></v-text-field>
                    <password
                        v-model="user.password"
                        :secureLength="8"
                        :strength-meter-only="true"
                    ></password>

                    <v-checkbox v-model="rules"
                                :error-messages="rulesErrors"
                                @change="$v.rules.$touch()">
                      <i18n path="common.agb" tag="span" slot="label">
                                                <span slot="tos"> <a @click.stop target="_blank"
                                                                     href='https://onsharesuite.com/files/AGBs.pdf'>
                                                  {{ $t('common.tos') }}</a></span>
                        <span slot="dataPrivacy"><a @click.stop target="_blank"
                                                    href='https://www.sharesuite.com/datenschutz/'>
                          {{ $t('common.dataPrivacy') }}</a>
                        </span>
                      </i18n>
                    </v-checkbox>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-container class="pt-0">
              <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="12">
                  <v-btn x-large color="success" class="register-button" @click="submit"
                         :disabled="loading">
                    {{ $t('register.start') }}
                  </v-btn>

                </v-col>
              </v-row>

              <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="12">
                  <router-link
                      class="caption"
                      :to="{ name: 'login' }">
                    {{ $t('common.loginLink') }}
                  </router-link>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
        v-model="loggedInDialog"
        max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('register.activeSession.title') }}
        </v-card-title>

        <v-card-text>
          {{ $t('register.activeSession.text') }}
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="primary"
              text
              @click="logout">
            {{ $t('register.activeSession.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import {required, minLength, sameAs, email} from 'vuelidate/lib/validators'
import Password from 'vue-password-strength-meter'

export default {
  name: 'RegisterUser2',
  components: {Password},

  validations() {
    const validations = {
      user: {
        email: {
          required, email
        },
        password: {
          required,
          minLength: minLength(8)
        }
      },
      rules: {
        sameAs: sameAs(() => true)
      }
    }

    return validations;
  },

  data: () => ({
    loading: false,
    error: null,
    loggedInDialog: false,

    showPassword: false,

    user: {
      email: '',
      password: ''
    },
    rules: null
  }),
  computed: {
    emailErrors() {
      const errors = []

      if(!this.$v.user.email.$dirty) {
        return errors
      }

      !this.$v.user.email.required && errors.push(this.$t('common.errors.fieldRequired'))
      return errors
    },
    passwordErrors() {
      const errors = []

      if(!this.$v.user.password.$dirty) {
        return errors
      }

      !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))
      !this.$v.user.password.minLength && errors.push(this.$t('common.errors.fieldMinLength', {amount: 8}))
      return errors
    },
    rulesErrors() {
      const errors = []

      if(!this.$v.rules.$dirty) {
        return errors
      }

      !this.$v.rules.sameAs && errors.push(this.$t('common.errors.fieldRequired'))
      return errors
    }
  },

  methods: {
    forwardToSharesuite(ctxId) {
      if(this.checkMobile()) {
        this.$router.push({
          name: 'register_assistant',
          params: {
            ctxId: ctxId
          }
        });
      } else {
        location.replace(location.origin + "/" + process.env.VUE_APP_WEB_APP_PATH)
      }
    },
    submit() {
      this.$v.$touch()
      if(!this.$v.$invalid) {
        this.error = null
        this.loading = true

        this.$store.dispatch('register2', {
          user: this.user
        }).then((response) => {
          this.loginAndForward()
        }).catch((response) => {
          switch(response.status) {
            case 418:
              if(response.data && response.data.result) {
                const error = response.data.result
                if(error.appId === 1 && error.errorId === 5) {
                  this.error = this.$t('common.errors.userExists')
                } else {
                  this.error = this.$t('common.errors.commonError')
                }
              }
              break
            default:
              // Unexpected system errors
              this.error = this.$t('common.errors.commonError')
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },

    loginAndForward() {
      this.$store.dispatch('login', {
        user: {
          userName: this.user.email,
          password: this.user.password
        }
      }).then((response) => {
        if(response.success === true && response.result !== false && response.result.user) {
          this.forwardToSharesuite(response.result.user.defaultContextId)
        } else if(response.result.appId === 0) {
          const errorId = response.result.errorId
          switch(errorId) {
            case 11:
              this.loggedInDialog = true
              break
            default:
              this.$router.push({name: 'register_success'})
          }
        }
      }).catch((response) => {
        if(response.data && response.data.result && response.data.result.appId === 0) {
          const errorId = response.data.result.errorId
          switch(errorId) {
            case 11:
              this.loggedInDialog = true
              break
            default:
              // Unexpected system errors
              this.error = this.$t('common.errors.commonError')
          }
        } else {
          this.error = this.$t('common.errors.commonError')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    logout: function() {
      this.$store.dispatch('logout').then(this.loginAndForward)
    },
    checkMobile: function() {
      let check = false;
      (function(a)
      {if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.register-button {
  width: 100%;
  text-transform: initial;
}

.v-card__text {
  padding-top: 0;
  padding-bottom: 0 !important;
}

.header-image-container {
  height: 75px;
}

.pointer {
  cursor: pointer;
}
</style>
